import { render, staticRenderFns } from "./ReportHistoryTable.vue?vue&type=template&id=fb60ac1a"
import script from "./ReportHistoryTable.vue?vue&type=script&lang=js"
export * from "./ReportHistoryTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports